import React, { useState, useContext, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, NavLink } from 'react-router-dom';
import TopicList from './components/TopicList';
import TopicDetail from './components/TopicDetail';
import SubtopicDetail from './components/SubtopicDetail';
import Mission from './components/Mission';
import Login from './components/Login';
import Register from './components/Register';
import EmailManagement from './components/EmailManagement';
import Footer from './components/Footer';
import SearchResults from './components/SearchResults';
import SearchBar from './components/SearchBar';
import AuthSuccess from './components/AuthSuccess';
import logo from './assets/The Other Side.png';
import './App.css';
import { AuthContext } from './contexts/AuthContext';

const generateUrl = (name) => {
  if (!name) {
    console.error('Name is undefined or null:', name);
    return ''; // Return a default value or handle it as necessary
  }
  return name.toLowerCase().replace(/ /g, '-').replace(/\//g, '-');
};

function App() {
  const { user, setUser, loading } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [appId] = useState(Math.random().toString(36).substring(2, 9));

  console.log(`[App:${appId}] Rendering App component, user:`, user);

  useEffect(() => {
    console.log(`[App:${appId}] Checking authentication status`);
    const storedUser = localStorage.getItem('user');
    if (storedUser && !user) {
      try {
        const parsedUser = JSON.parse(storedUser);
        console.log(`[App:${appId}] Setting user from localStorage:`, parsedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error(`[App:${appId}] Error parsing stored user:`, error);
        localStorage.removeItem('user');
      }
    }
  }, [appId, user, setUser]);

  const handleLogout = (e) => {
    e.preventDefault();
    console.log(`[App:${appId}] Logging out user`);
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  const handleSearch = async (query) => {
    console.log(`[App:${appId}] Search query:`, query);
    try {
      const response = await fetch(`/api/search?q=${encodeURIComponent(query)}`);
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const results = await response.json();
        console.log(`[App:${appId}] Search results:`, results);
        setSearchResults(results);
      } else {
        const errorText = await response.text();
        console.error(`[App:${appId}] Unexpected response:`, errorText);
      }
    } catch (error) {
      console.error(`[App:${appId}] Error fetching search results:`, error);
    }
  };

  if (loading) {
    console.log(`[App:${appId}] Loading state, showing loading indicator`);
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <nav className="navbar navbar-light bg-light">
          <div className="container">
            <div className="d-flex align-items-center justify-content-center w-100">
              <NavLink className="navbar-brand mx-2" to="/topics">
                <img src={logo} alt="The Other Side" height="30" />
              </NavLink>
              <NavLink className="nav-link mx-2" to="/topics">Topics</NavLink>
              <NavLink className="nav-link mx-2" to="/mission">Mission</NavLink>
              {user ? (
                <>
                  <span className="nav-link mx-2" style={{ color: '#333333' }}>Welcome, {user.username || user.email}</span>
                  <NavLink className="nav-link mx-2" to="#" onClick={handleLogout}>Logout</NavLink>
                </>
              ) : (
                <>
                  <NavLink className="nav-link mx-2" to="/login">Login</NavLink>
                  <NavLink className="nav-link mx-2" to="/register">Register</NavLink>
                </>
              )}
              <SearchBar onSearch={handleSearch} className="mx-2" />
            </div>
          </div>
        </nav>

        <div className="content container">
          <Routes>
            <Route path="/" element={<TopicList />} />
            <Route path="/topics" element={<TopicList />} />
            <Route path="/topics/:name" element={<TopicDetail />} />
            <Route path="/subtopics/:identifier" element={<SubtopicDetail user={user} />} />
            <Route path="/mission" element={<Mission />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth-success" element={<AuthSuccess />} />
            <Route path="/email-management" element={<EmailManagement />} />
            <Route path="/search" element={<SearchResults results={searchResults} />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
